import React from "react";
import { Car } from "phosphor-react";
import Select from "../Inputs/Select";
import Loading from "../Loading/Loading";
import SelectObject from "../Inputs/SelectObject";

export function ModelSelectUsed({
  models,
  setModel,
  setPrepopulateItem,
  model,
  isFetchingModels,
  validate,
}) {
  return (
    <SelectObject
      options={models?.map((m) => ({ option: m.model, crmID: m?.crM_ID, info: `${m?.transmission} ${m?.fuel} ${m?.crM_ID}` }))}
      defaultValue={
        !models || models?.length === 0
          ? "No models"
          : `Select (${models?.length})`
      }
      handleChange={(value) => {
        setModel(value.option);
        setPrepopulateItem(models?.find((m) => m.crM_ID === value.crmID));
      }}
      value={model}
      prefix={
        isFetchingModels ? (
          <Loading />
        ) : (
          <Car size={14} weight="regular" color="var(--carter-secondary)" />
        )
      }
      label="Model*"
      id="model"
      validate={validate}
    />
  );
}
